import { Pathname } from "./pathnames/pathname";
import image from "../assets/images";
import { PathnameUsers } from "./pathnames/pathname.user";
import { PathnameAccounting } from "./pathnames/pathname.accounting";
import { PathnameDocument } from "./pathnames/pathname.document";
import { PathnameInventory } from "./pathnames/pathname.inventory";
import { PathnameManufacturing } from "./pathnames/pathname.manufacturing";
import { PathnameCrm } from "./pathnames/pathname.crm";
import { PathnamePurchase } from "./pathnames/pathname.procurement";
import { PathnameRental } from "./pathnames/pathname.rental";
import { PathnameHrms } from "./pathnames/pathname.hrms";
import { PathnameOnBoarding } from "./pathnames/pathname.onboarding";
import { getApiConfig } from "../utils/api-config";
import { getModuleRoutes } from "../utils/module-routes-config";

// Helper to conditionally create the onboarding menu item
const getOnboardingMenuItem = (t: any, env: string) => {
  if (!['ksa'].includes(env)) {
    return [];
  }

  return [
    {
      label: t("onboarding.name"),
      link: Pathname.DASHBOARD_ONBOARDING,
      sidebar: image.sidebar.user,
      bacModuleName: "user",
      icon: image.user,
      permission: "",
      beModuleName: "rbac",
       bg: "#F3E8FF",
      connectedRoutes: Object.values(PathnameOnBoarding).map(
        (path: string) => Pathname.DASHBOARD_ONBOARDING + path
      ),
      translationModule: ["onboarding"],
    },
  ];
};

const modules = (t: any) => {
  const u_data = localStorage.getItem("_u_data") || undefined;
  const userData = u_data ? JSON.parse(u_data) : "";
  const config: any = getApiConfig();
  const access_modules = userData?.module_access || [];
  const VITE_APP_ENV = config?.zatcaEnvironment || 'simulation';
  const accessibleModules = access_modules.map((module: any) => module.module_name);
  const accessibleModulesSet = new Set(accessibleModules);

  const MenuBar = [
    {
      label: t("common.modules.user.title"),
      link: Pathname.DASHBOARD_USER,
      sidebar: image.sidebar.user,
      bacModuleName: "user",
      icon: image.user,
      permission: "",
      beModuleName: "rbac",
      bg: "#F3E8FF",
      connectedRoutes: Object.values(PathnameUsers).map(
        (path: string) => Pathname.DASHBOARD_USER + path
      ),
      translationModule: ["user"]
    },
    {
      label: t("common.modules.document.title"),
      link: Pathname.DASHBOARD_DOCUMENT,
      sidebar: image.sidebar.document,
      bacModuleName: "document",
      icon: image.document,
      permission: "",
      beModuleName: "document",
      bg: "#E0F2FE",
      connectedRoutes: Object.values(PathnameDocument).map(
        (path: string) => Pathname.DASHBOARD_DOCUMENT + path
      ),
      translationModule: ["document"]
    },
    {
      label: t("common.modules.accounting.title"),
      link: Pathname.DASHBOARD_ACCOUNTING,
      sidebar: image.sidebar.accountingIcon,
      bacModuleName: "accounts-and-finance",
      icon: image.accounting,
      permission: "",
      beModuleName: "accounts-and-finance",
      bg: "#E8EAF6",
      connectedRoutes: Object.values(PathnameAccounting).map(
        (path: string) => Pathname.DASHBOARD_ACCOUNTING + path
      ),
      translationModule: ["accounting"]
    },
    {
      label: t("common.modules.inventory.title"),
      link: Pathname.DASHBOARD_INVENTORY,
      sidebar: image.sidebar.inventoryIcon,
      bacModuleName: "inventory",
      icon: image.inventory,
      permission: "",
      beModuleName: "inventory",
      bg: "#FFF3E6",
      connectedRoutes: Object.values(PathnameInventory).map(
        (path: string) => Pathname.DASHBOARD_INVENTORY + path
      ),
      translationModule: ["inventory"]
    },
    {
      label: t("common.modules.project.title"),
      link: Pathname.DASHBOARD_PROJECT,
      sidebar: image.sidebar.projectIcon,
      bacModuleName: "project",
      icon: image.project,
      permission: "",
      beModuleName: "project",
      bg: "#DCFCE7",
      connectedRoutes: [],
      translationModule: ["project"]
    },
    {
      label: t("common.modules.procurement.title"),
      link: Pathname.DASHBOARD_PROCUREMENT,
      sidebar: image.sidebar.procurementIcon,
      bacModuleName: "purchase",
      icon: image.procurement,
      permission: "",
      beModuleName: "purchase",
      bg: "#FFEBE6",
      connectedRoutes: Object.values(PathnamePurchase).map(
        (path: string) => Pathname.DASHBOARD_PROCUREMENT + path
      ),
      // connectedRoutes: [],
      translationModule: ["procurement", "accounting"]
    },
    {
      label: t("common.modules.manufacturing.title"),
      link: Pathname.DASHBOARD_MANUFACTURING,
      sidebar: image.sidebar.manufacturingIcon,
      bacModuleName: "manufacturing",
      icon: image.manufacturing,
      permission: "",
      beModuleName: "manufacturing",
      bg: "#F0FDF4",
      connectedRoutes: Object.values(PathnameManufacturing).map(
        (path: string) => Pathname.DASHBOARD_MANUFACTURING + path
      ),
      translationModule: ["manufacturing"]
    },
    {
      label: t("common.modules.crm.title"),
      link: Pathname.DASHBOARD_CRM,
      sidebar: image.sidebar.crmIcon,
      bacModuleName: "sales",
      icon: image.crm,
      permission: "",
      beModuleName: "sales",
      bg: "#FCEBEC",
      connectedRoutes: Object.values(PathnameCrm).map(
        (path: string) => Pathname.DASHBOARD_CRM + path
      ),
      translationModule: ["crm", "accounting"]
    },
    // {
    //   label: t("purchase.name"),
    //   link: Pathname.DASHBOARD_PURCHASE,
    //   sidebar: image.sidebar.purchaseIcon,
    //   icon: image.sidebar.purchaseIcon,
    //   permission: "",
    //   bg: "rgba(111, 102, 215, 0.10)",
    //   connectedRoutes: [],
    // },
    {
      label: t("common.modules.hrms.title"),
      link: Pathname.DASHBOARD_HRMS,
      sidebar: image.sidebar.hrmsIcon,
      bacModuleName: "hrms",
      icon: image.hrms,
      permission: "",
      beModuleName: "hrms",
      bg: "#EBF9F2",
      connectedRoutes: (() => {
        // Prefer MFE-injected routes (set via ERPUIProvider's moduleRoutes prop)
        // which contain the full, up-to-date route list from the HRMS MFE.
        // Fall back to common-hub's PathnameHrms if no MFE routes were injected.
        const mfeRoutes = getModuleRoutes('hrms');
        if (mfeRoutes.length > 0) return mfeRoutes;
        return Object.values(PathnameHrms).map(
          (path: string) => Pathname.DASHBOARD_HRMS + path
        );
      })(),
      translationModule: ["hrms"]
    },
    {
      label: t("common.modules.office.title"),
      link: Pathname.DASHBOARD_OFFICE,
      sidebar: image.sidebar.officeIcon,
      bacModuleName: "office",
      icon: image.office,
      permission: "",
      beModuleName: "office",
      bg: "#DCFCE7",
      connectedRoutes: [],
      translationModule: ["office"]
    },
    {
      label: t("common.modules.rental.title"),
      link: Pathname.DASHBOARD_RENTAL,
      sidebar: image.sidebar.rentalIcon,
      bacModuleName: "rental",
      icon: image.rental,
      permission: "",
      beModuleName: "rental",
      bg: "#FEF3C7",
      connectedRoutes: Object.values(PathnameRental).map(
        (path: string) => Pathname.DASHBOARD_RENTAL + path
      ),
      translationModule: ["rental","inventory"]
    },
    {
      label: t("common.modules.settings.title"),
      link: Pathname.DASHBOARD_QUOTES,
      sidebar: image.sidebar.setting,
      bacModuleName: "setting",
      icon: image.settings,
      permission: "",
      beModuleName: "setting",
      bg: "#EEF2FF",
      connectedRoutes: [],
      translationModule: ["settings"]
    },
    ...getOnboardingMenuItem(t, VITE_APP_ENV),
  ];

  function filterMenu(menu: any[]) {
    return menu.filter((item) => {
      const isModuleAccessible = accessibleModulesSet.has(item.bacModuleName);
      let hasValidSubmenu = false;

      if (item.submenu && item.submenu.length > 0) {
        item.submenu = filterMenu(item.submenu); // Recursively filter submenu
        hasValidSubmenu = item.submenu.length > 0;
      }

      return isModuleAccessible || hasValidSubmenu;
    });
  }

  const filteredMenu = filterMenu(MenuBar);

  return filteredMenu;
};

export default modules;